// ========== 安全的 Storage 操作工具 ==========
export const safeStorage = {
    get(type, key) {
        try {
            const storage = type === 'local' ? localStorage : sessionStorage;
            return storage.getItem(key);
        } catch(e) {
            console.warn('[Storage] Failed to get item:', key, e.message);
            return null;
        }
    },
    set(type, key, value) {
        try {
            const storage = type === 'local' ? localStorage : sessionStorage;
            const data = typeof value === 'string' ? value : JSON.stringify(value);
            storage.setItem(key, data);
            return true;
        } catch(e) {
            console.warn('[Storage] Failed to set item:', key, e.message);
            return false;
        }
    },
    remove(type, key) {
        try {
            const storage = type === 'local' ? localStorage : sessionStorage;
            storage.removeItem(key);
            return true;
        } catch(e) {
            console.warn('[Storage] Failed to remove item:', key, e.message);
            return false;
        }
    }
};
